/*
* Report page
*/

import * as React from 'react';
import ReactImageFallback from 'react-image-fallback';

import stringtemplate from 'string-template';
import { Formatters } from '../../../common/formatters';
import ApiEndpoints from '../../../config/apiendpoints';
import * as OrderCommon from '../../order-common';
import * as BidLetterReportComponents from '../report-components';

export const Render = ({ reportData, ...rest }) => {
    const { currentOrder, branding, association, associationClient, orderClient, pricingMatrix, orderServicesPricingMatrix, serviceLevels, orderManagerUser, bidLetterTextContents, ...otherReportData } = reportData;

    const orderAssocCompanyBrandKey = Formatters.getStr(currentOrder, 'company.brandKey');
    const orderClientStateCode = Formatters.getStr(currentOrder, 'association.client.location.stateCode');

    const selectedProjectsStringObj = {
        text:
            `<h4>WE HAVE <b>EXPERIENCE</b> WITH A VARIETY OF CLIENTS</h4>
        
        <p>We've worked on projects of all sizes alongside a wide range of clients. This experience allows us to find solutions to any challenge and deliver a suitable reserve study tailored to your situation, no matter what that may be.</p>

        <h5><b>CONDOS</b></h5>
        
        <ul>
        <li>Budget responsibly and skip unnecessary costs with a proper long-term plan for your condominiums.</li>
        </ul>
        <h5><b>HIGH RISES</b></h5>
        
        <ul>
        <li>Avoid unnecessary or unexpected maintenance costs without cutting corners.</li>
        </ul>
        <h5><b>RELIGIOUS CENTERS</b></h5>
        
        <ul>
        <li>Focus on your fellowship, let us focus on your facilities.</li>
        </ul>
        <h5><b>SCHOOLS & UNIVERSITIES</b></h5>
        
        <ul>
        <li>Get actionable plans to maintain the structural integrity of your institution's infrastructure.</li>
        </ul>
        <h5><b>PRIVATE CLUBS</b></h5>
        
        <ul>
        <li>Keep your investment profitable for longer with a proper reserve study.</li>
        </ul>
        <h5><b>SPECIAL DISTRICTS</b></h5>
        
        <ul>
        <li>Ensure your utility district, fire dept, etc. continue to provide services for your constituents.</li>
        </ul>
        <h5><b>MARINAS & DOCK ASSOCIATIONS</b></h5>
        
        <ul>
        <li>Reduce deterioration and increase the longevity of your water-based facilities.</li>
        </ul>
        <h5><b>TIMESHARES & RESORTS</b></h5>
        
        <ul>
        <li>Preserve, protect, and enhance the vacation experience for your members and guests.</li>
        </ul>
        <h5><b>SINGLE FAMILY HOME COMMUNITIES</b></h5>
        
        <ul>
        <li>Maintain and potentially increase property values while enhancing quality of living.</li>
        </ul>
        <h5><b>MASTER ASSOCIATIONS</b></h5>
        
        <ul>
        <li>Consistent and quality budgets for the long-term goals of the master association and its residents.</li>
        </ul>
        <h5><b>RETIREMENT COMMUNITIES</b></h5>
        
        <ul>
        <li>Helping to ensure a consistent and long-term budget that helps prevent unexpected expenses.</li>
        </ul>
        <h5><b>COMMERCIAL PROPERTIES</b></h5>
        
        <ul>
        <li>Maintain and grow values of commercial properties for a variety of clients in a fast-paced environment.</li>
        </ul>
        `
    };

    const selectedProjectsText = stringtemplate(Formatters.getStr(selectedProjectsStringObj, 'text', 'ERROR'));

    // Header image
    let headerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-header.png`;
    let headerNotFoundPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-header.png`;

    switch (orderClientStateCode) {
        case OrderCommon.BidLetterStateCodes.Nevada:
            headerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-header.png`;
            break;

        default:
            headerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-header-other.png`;
            break;
    }

    const headerImageObj = {
        src: ApiEndpoints.getBidLetterUserSignaturePictureUrl(headerPath, false),
        fallbackSrc: ApiEndpoints.getBidLetterUserSignaturePictureUrl(headerNotFoundPath, false),
    };

    // Footer image
    let footerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-footer.png`;
    let footerNotFoundPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-footer.png`;

    const footerImageObj = {
        src: ApiEndpoints.getBidLetterUserSignaturePictureUrl(footerPath, false),
        fallbackSrc: ApiEndpoints.getBidLetterUserSignaturePictureUrl(footerNotFoundPath, false),
    };

    const headerImage = (
        <div>
            <ReactImageFallback
                src={headerImageObj.src}
                fallbackImage={headerImageObj.fallbackSrc}
                className="pdf-order-bid-letter-header-image"
            />
        </div>
    );

    const footerImage = (
        <div className="pdf-order-bid-letter-footer-container">
            <ReactImageFallback
                src={footerImageObj.src}
                fallbackImage={footerImageObj.fallbackSrc}
                className="pdf-order-bid-letter-footer-image"
            />
        </div>
    );

    const bodyContent = (
        <div className="pdf-order-bid-letter-body-content">
            {<div dangerouslySetInnerHTML={{ __html: selectedProjectsText }} />}
        </div>);

    return (
        <div>
            <BidLetterReportComponents.ReportPage className="pdf-order-bid-letter-cover-page" reportData={reportData}>
                {headerImage}
                {bodyContent}
                {footerImage}
            </BidLetterReportComponents.ReportPage>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/order/bid-letter/pages/report-page-selected-projects.tsx